import { getRequest } from '@/core';
import { maintenance } from '@/requests';

export default async function getDeviationCausesRequest() {
	let url = maintenance.getDeviationCausesPath();
	return getRequest(url);
}